import { render, staticRenderFns } from "./DataTableField.vue?vue&type=template&id=82004608&scoped=true"
import script from "./DataTableField.vue?vue&type=script&lang=ts"
export * from "./DataTableField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82004608",
  null
  
)

export default component.exports